export { SecureDocumentShareDialog } from './SecureDocumentShareDialog';
export type { SecureDocumentShareDialogProps } from './SecureDocumentShareDialog.types';
